const ililce = [
  {
    il: "Adana",
    plaka: 1,
    ilceleri: [
      "Aladağ",
      "Ceyhan",
      "Çukurova",
      "Feke",
      "İmamoğlu",
      "Karaisalı",
      "Karataş",
      "Kozan",
      "Pozantı",
      "Saimbeyli",
      "Sarıçam",
      "Seyhan",
      "Tufanbeyli",
      "Yumurtalık",
      "Yüreğir"
    ]
  },
  {
    il: "Adıyaman",
    plaka: 2,
    ilceleri: [
      "Besni",
      "Çelikhan",
      "Gerger",
      "Gölbaşı",
      "Kahta",
      "Merkez",
      "Samsat",
      "Sincik",
      "Tut"
    ]
  },
  {
    il: "Afyonkarahisar",
    plaka: 3,
    ilceleri: [
      "Başmakçı",
      "Bayat",
      "Bolvadin",
      "Çay",
      "Çobanlar",
      "Dazkırı",
      "Dinar",
      "Emirdağ",
      "Evciler",
      "Hocalar",
      "İhsaniye",
      "İscehisar",
      "Kızılören",
      "Merkez",
      "Sandıklı",
      "Sinanpaşa",
      "Sultandağı",
      "Şuhut"
    ]
  },
  {
    il: "Ağrı",
    plaka: 4,
    ilceleri: [
      "Diyadin",
      "Doğubayazıt",
      "Eleşkirt",
      "Hamur",
      "Merkez",
      "Patnos",
      "Taşlıçay",
      "Tutak"
    ]
  },
  {
    il: "Amasya",
    plaka: 5,
    ilceleri: [
      "Göynücek",
      "Gümüşhacıköy",
      "Hamamözü",
      "Merkez",
      "Merzifon",
      "Suluova",
      "Taşova"
    ]
  },
  {
    il: "Ankara",
    plaka: 6,
    ilceleri: [
      "Akyurt",
      "Altındağ",
      "Ayaş",
      "Bala",
      "Beypazarı",
      "Çamlıdere",
      "Çankaya",
      "Çubuk",
      "Elmadağ",
      "Etimesgut",
      "Evren",
      "Gölbaşı",
      "Güdül",
      "Haymana",
      "Kalecik",
      "Kazan",
      "Keçiören",
      "Kızılcahamam",
      "Mamak",
      "Nallıhan",
      "Polatlı",
      "Pursaklar",
      "Sincan",
      "Şereflikoçhisar",
      "Yenimahalle"
    ]
  },
  {
    il: "Antalya",
    plaka: 7,
    ilceleri: [
      "Akseki",
      "Aksu",
      "Alanya",
      "Demre",
      "Döşemealtı",
      "Elmalı",
      "Finike",
      "Gazipaşa",
      "Gündoğmuş",
      "İbradı",
      "Kaş",
      "Kemer",
      "Kepez",
      "Konyaaltı",
      "Korkuteli",
      "Kumluca",
      "Manavgat",
      "Muratpaşa",
      "Serik"
    ]
  },
  {
    il: "Artvin",
    plaka: 8,
    ilceleri: [
      "Ardanuç",
      "Arhavi",
      "Borçka",
      "Hopa",
      "Merkez",
      "Murgul",
      "Şavşat",
      "Yusufeli"
    ]
  },
  {
    il: "Aydın",
    plaka: 9,
    ilceleri: [
      "Bozdoğan",
      "Buharkent",
      "Çine",
      "Didim",
      "Efeler",
      "Germencik",
      "İncirliova",
      "Karacasu",
      "Karpuzlu",
      "Koçarlı",
      "Köşk",
      "Kuşadası",
      "Kuyucak",
      "Merkez",
      "Nazilli",
      "Söke",
      "Sultanhisar",
      "Yenipazar"
    ]
  },
  {
    il: "Balıkesir",
    plaka: 10,
    ilceleri: [
      "Altıeylül",
      "Ayvalık",
      "Balya",
      "Bandırma",
      "Bigadiç",
      "Burhaniye",
      "Dursunbey",
      "Edremit",
      "Erdek",
      "Gömeç",
      "Gönen",
      "Havran",
      "İvrindi",
      "Karesi",
      "Kepsut",
      "Manyas",
      "Marmara",
      "Merkez",
      "Savaştepe",
      "Sındırgı",
      "Susurluk"
    ]
  },
  {
    il: "Bilecik",
    plaka: 11,
    ilceleri: [
      "Bozüyük",
      "Gölpazarı",
      "İnhisar",
      "Merkez",
      "Osmaneli",
      "Pazaryeri",
      "Söğüt",
      "Yenipazar"
    ]
  },
  {
    il: "Bingöl",
    plaka: 12,
    ilceleri: [
      "Adaklı",
      "Genç",
      "Karlıova",
      "Kiğı",
      "Merkez",
      "Solhan",
      "Yayladere",
      "Yedisu"
    ]
  },
  {
    il: "Bitlis",
    plaka: 13,
    ilceleri: [
      "Adilcevaz",
      "Ahlat",
      "Güroymak",
      "Hizan",
      "Merkez",
      "Mutki",
      "Tatvan"
    ]
  },
  {
    il: "Bolu",
    plaka: 14,
    ilceleri: [
      "Dörtdivan",
      "Gerede",
      "Göynük",
      "Kıbrıscık",
      "Mengen",
      "Merkez",
      "Mudurnu",
      "Seben",
      "Yeniçağa"
    ]
  },
  {
    il: "Burdur",
    plaka: 15,
    ilceleri: [
      "Ağlasun",
      "Altınyayla",
      "Bucak",
      "Çavdır",
      "Çeltikçi",
      "Gölhisar",
      "Karamanlı",
      "Kemer",
      "Merkez",
      "Tefenni",
      "Yeşilova"
    ]
  },
  {
    il: "Bursa",
    plaka: 16,
    ilceleri: [
      "Büyükorhan",
      "Gemlik",
      "Gürsu",
      "Harmancık",
      "İnegöl",
      "İznik",
      "Karacabey",
      "Keles",
      "Kestel",
      "Mudanya",
      "Mustafakemalpaşa",
      "Nilüfer",
      "Orhaneli",
      "Orhangazi",
      "Osmangazi",
      "Yenişehir",
      "Yıldırım"
    ]
  },
  {
    il: "Çanakkale",
    plaka: 17,
    ilceleri: [
      "Ayvacık",
      "Bayramiç",
      "Biga",
      "Bozcaada",
      "Çan",
      "Eceabat",
      "Ezine",
      "Gelibolu",
      "Gökçeada",
      "Lapseki",
      "Merkez",
      "Yenice"
    ]
  },
  {
    il: "Çankırı",
    plaka: 18,
    ilceleri: [
      "Atkaracalar",
      "Bayramören",
      "Çerkeş",
      "Eldivan",
      "Ilgaz",
      "Kızılırmak",
      "Korgun",
      "Kurşunlu",
      "Merkez",
      "Orta",
      "Şabanözü",
      "Yapraklı"
    ]
  },
  {
    il: "Çorum",
    plaka: 19,
    ilceleri: [
      "Alaca",
      "Bayat",
      "Boğazkale",
      "Dodurga",
      "İskilip",
      "Kargı",
      "Laçin",
      "Mecitözü",
      "Merkez",
      "Oğuzlar",
      "Ortaköy",
      "Osmancık",
      "Sungurlu",
      "Uğurludağ"
    ]
  },
  {
    il: "Denizli",
    plaka: 20,
    ilceleri: [
      "Acıpayam",
      "Babadağ",
      "Baklan",
      "Bekilli",
      "Beyağaç",
      "Bozkurt",
      "Buldan",
      "Çal",
      "Çameli",
      "Çardak",
      "Çivril",
      "Güney",
      "Honaz",
      "Kale",
      "Merkezefendi",
      "Merkez",
      "Pamukkale",
      "Sarayköy",
      "Serinhisar",
      "Tavas"
    ]
  },
  {
    il: "Diyarbakır",
    plaka: 21,
    ilceleri: [
      "Bağlar",
      "Bismil",
      "Çermik",
      "Çınar",
      "Çüngüş",
      "Dicle",
      "Eğil",
      "Ergani",
      "Hani",
      "Hazro",
      "Kayapınar",
      "Kocaköy",
      "Kulp",
      "Lice",
      "Silvan",
      "Sur",
      "Yenişehir"
    ]
  },
  {
    il: "Edirne",
    plaka: 22,
    ilceleri: [
      "Enez",
      "Havsa",
      "İpsala",
      "Keşan",
      "Lalapaşa",
      "Merkez",
      "Meriç",
      "Süloğlu",
      "Uzunköprü"
    ]
  },
  {
    il: "Elazığ",
    plaka: 23,
    ilceleri: [
      "Ağın",
      "Alacakaya",
      "Arıcak",
      "Baskil",
      "Karakoçan",
      "Keban",
      "Kovancılar",
      "Maden",
      "Merkez",
      "Palu",
      "Sivrice"
    ]
  },
  {
    il: "Erzincan",
    plaka: 24,
    ilceleri: [
      "Çayırlı",
      "İliç",
      "Kemah",
      "Kemaliye",
      "Merkez",
      "Otlukbeli",
      "Refahiye",
      "Tercan",
      "Üzümlü"
    ]
  },
  {
    il: "Erzurum",
    plaka: 25,
    ilceleri: [
      "Aşkale",
      "Aziziye",
      "Çat",
      "Hınıs",
      "Horasan",
      "İspir",
      "Karaçoban",
      "Karayazı",
      "Köprüköy",
      "Narman",
      "Oltu",
      "Olur",
      "Palandöken",
      "Pasinler",
      "Pazaryolu",
      "Şenkaya",
      "Tekman",
      "Tortum",
      "Uzundere",
      "Yakutiye"
    ]
  },
  {
    il: "Eskişehir",
    plaka: 26,
    ilceleri: [
      "Alpu",
      "Beylikova",
      "Çifteler",
      "Günyüzü",
      "Han",
      "İnönü",
      "Mahmudiye",
      "Mihalgazi",
      "Mihalıççık",
      "Odunpazarı",
      "Sarıcakaya",
      "Seyitgazi",
      "Sivrihisar",
      "Tepebaşı"
    ]
  },
  {
    il: "Gaziantep",
    plaka: 27,
    ilceleri: [
      "Araban",
      "İslahiye",
      "Karkamış",
      "Nizip",
      "Nurdağı",
      "Oğuzeli",
      "Şahinbey",
      "Şehitkamil",
      "Yavuzeli"
    ]
  },
  {
    il: "Giresun",
    plaka: 28,
    ilceleri: [
      "Alucra",
      "Bulancak",
      "Çamoluk",
      "Çanakçı",
      "Dereli",
      "Doğankent",
      "Espiye",
      "Eynesil",
      "Görele",
      "Güce",
      "Keşap",
      "Merkez",
      "Piraziz",
      "Şebinkarahisar",
      "Tirebolu",
      "Yağlıdere"
    ]
  },
  {
    il: "Gümüşhane",
    plaka: 29,
    ilceleri: [
      "Kelkit",
      "Köse",
      "Kürtün",
      "Merkez",
      "Şiran",
      "Torul"
    ]
  },
  {
    il: "Hakkari",
    plaka: 30,
    ilceleri: [
      "Çukurca",
      "Merkez",
      "Şemdinli",
      "Yüksekova"
    ]
  },
  {
    il: "Hatay",
    plaka: 31,
    ilceleri: [
      "Altınözü",
      "Antakya",
      "Arsuz",
      "Belen",
      "Defne",
      "Dörtyol",
      "Erzin",
      "Hassa",
      "İskenderun",
      "Kırıkhan",
      "Kumlu",
      "Payas",
      "Reyhanlı",
      "Samandağ",
      "Yayladağı"
    ]
  },
  {
    il: "Isparta",
    plaka: 32,
    ilceleri: [
      "Aksu",
      "Atabey",
      "Eğirdir",
      "Gelendost",
      "Gönen",
      "Keçiborlu",
      "Merkez",
      "Senirkent",
      "Sütçüler",
      "Şarkikaraağaç",
      "Uluborlu",
      "Yalvaç",
      "Yenişarbademli"
    ]
  },
  {
    il: "Mersin",
    plaka: 33,
    ilceleri: [
      "Akdeniz",
      "Anamur",
      "Aydıncık",
      "Bozyazı",
      "Çamlıyayla",
      "Erdemli",
      "Gülnar",
      "Mezitli",
      "Mut",
      "Silifke",
      "Tarsus",
      "Toroslar",
      "Yenişehir"
    ]
  },
  {
    il: "İstanbul",
    plaka: 34,
    ilceleri: [
      "Adalar",
      "Arnavutköy",
      "Ataşehir",
      "Avcılar",
      "Bağcılar",
      "Bahçelievler",
      "Bakırköy",
      "Başakşehir",
      "Bayrampaşa",
      "Beşiktaş",
      "Beykoz",
      "Beylikdüzü",
      "Beyoğlu",
      "Büyükçekmece",
      "Çatalca",
      "Çekmeköy",
      "Esenler",
      "Esenyurt",
      "Eyüpsultan",
      "Fatih",
      "Gaziosmanpaşa",
      "Güngören",
      "Kadıköy",
      "Kağıthane",
      "Kartal",
      "Küçükçekmece",
      "Maltepe",
      "Pendik",
      "Sancaktepe",
      "Sarıyer",
      "Silivri",
      "Sultanbeyli",
      "Sultangazi",
      "Şile",
      "Şişli",
      "Tuzla",
      "Ümraniye",
      "Üsküdar",
      "Zeytinburnu"
    ]
  },
  {
    il: "İzmir",
    plaka: 35,
    ilceleri: [
      "Aliağa",
      "Balçova",
      "Bayındır",
      "Bayraklı",
      "Bergama",
      "Beydağ",
      "Bornova",
      "Buca",
      "Çeşme",
      "Çiğli",
      "Dikili",
      "Foça",
      "Gaziemir",
      "Güzelbahçe",
      "Karabağlar",
      "Karaburun",
      "Karşıyaka",
      "Kemalpaşa",
      "Kınık",
      "Kiraz",
      "Konak",
      "Menderes",
      "Menemen",
      "Narlıdere",
      "Ödemiş",
      "Seferihisar",
      "Selçuk",
      "Tire",
      "Torbalı",
      "Urla"
    ]
  },
  {
    il: "Kars",
    plaka: 36,
    ilceleri: [
      "Akyaka",
      "Arpaçay",
      "Digor",
      "Kağızman",
      "Merkez",
      "Sarıkamış",
      "Selim",
      "Susuz"
    ]
  },
  {
    il: "Kastamonu",
    plaka: 37,
    ilceleri: [
      "Abana",
      "Ağlı",
      "Araç",
      "Azdavay",
      "Bozkurt",
      "Cide",
      "Çatalzeytin",
      "Daday",
      "Devrekani",
      "Doğanyurt",
      "Hanönü",
      "İhsangazi",
      "İnebolu",
      "Küre",
      "Merkez",
      "Pınarbaşı",
      "Seydiler",
      "Şenpazar",
      "Taşköprü",
      "Tosya"
    ]
  },
  {
    il: "Kayseri",
    plaka: 38,
    ilceleri: [
      "Akkışla",
      "Bünyan",
      "Develi",
      "Felahiye",
      "Hacılar",
      "İncesu",
      "Kocasinan",
      "Melikgazi",
      "Özvatan",
      "Pınarbaşı",
      "Sarıoğlan",
      "Sarız",
      "Talas",
      "Tomarza",
      "Yahyalı",
      "Yeşilhisar"
    ]
  },
  {
    il: "Kırklareli",
    plaka: 39,
    ilceleri: [
      "Babaeski",
      "Demirköy",
      "Kofçaz",
      "Lüleburgaz",
      "Merkez",
      "Pehlivanköy",
      "Pınarhisar",
      "Vize"
    ]
  },
  {
    il: "Kırşehir",
    plaka: 40,
    ilceleri: [
      "Akçakent",
      "Akpınar",
      "Boztepe",
      "Çiçekdağı",
      "Kaman",
      "Merkez",
      "Mucur"
    ]
  },
  {
    il: "Kocaeli",
    plaka: 41,
    ilceleri: [
      "Başiskele",
      "Çayırova",
      "Darıca",
      "Derince",
      "Dilovası",
      "Gebze",
      "Gölcük",
      "İzmit",
      "Kandıra",
      "Karamürsel",
      "Kartepe",
      "Körfez"
    ]
  },
  {
    il: "Konya",
    plaka: 42,
    ilceleri: [
      "Ahırlı",
      "Akören",
      "Akşehir",
      "Altınekin",
      "Beyşehir",
      "Bozkır",
      "Cihanbeyli",
      "Çeltik",
      "Çumra",
      "Derbent",
      "Derebucak",
      "Doğanhisar",
      "Emirgazi",
      "Ereğli",
      "Güneysınır",
      "Hadim",
      "Halkapınar",
      "Hüyük",
      "Ilgın",
      "Kadınhanı",
      "Karapınar",
      "Karatay",
      "Kulu",
      "Meram",
      "Sarayönü",
      "Selçuklu",
      "Seydişehir",
      "Taşkent",
      "Tuzlukçu",
      "Yalıhüyük",
      "Yunak"
    ]
  },
  {
    il: "Kütahya",
    plaka: 43,
    ilceleri: [
      "Altıntaş",
      "Aslanapa",
      "Çavdarhisar",
      "Domaniç",
      "Dumlupınar",
      "Emet",
      "Gediz",
      "Hisarcık",
      "Merkez",
      "Pazarlar",
      "Simav",
      "Şaphane",
      "Tavşanlı"
    ]
  },
  {
    il: "Malatya",
    plaka: 44,
    ilceleri: [
      "Akçadağ",
      "Arapgir",
      "Arguvan",
      "Battalgazi",
      "Darende",
      "Doğanşehir",
      "Doğanyol",
      "Hekimhan",
      "Kale",
      "Kuluncak",
      "Merkez",
      "Pütürge",
      "Yazıhan",
      "Yeşilyurt"
    ]
  },
  {
    il: "Manisa",
    plaka: 45,
    ilceleri: [
      "Ahmetli",
      "Akhisar",
      "Alaşehir",
      "Demirci",
      "Gölmarmara",
      "Gördes",
      "Kırkağaç",
      "Köprübaşı",
      "Kula",
      "Merkez",
      "Salihli",
      "Sarıgöl",
      "Saruhanlı",
      "Selendi",
      "Soma",
      "Şehzadeler",
      "Turgutlu",
      "Yunusemre"
    ]
  },
  {
    il: "Kahramanmaraş",
    plaka: 46,
    ilceleri: [
      "Afşin",
      "Andırın",
      "Çağlayancerit",
      "Dulkadiroğlu",
      "Ekinözü",
      "Elbistan",
      "Göksun",
      "Merkez",
      "Nurhak",
      "Onikişubat",
      "Pazarcık",
      "Türkoğlu"
    ]
  },
  {
    il: "Mardin",
    plaka: 47,
    ilceleri: [
      "Artuklu",
      "Dargeçit",
      "Derik",
      "Kızıltepe",
      "Mazıdağı",
      "Merkez",
      "Midyat",
      "Nusaybin",
      "Ömerli",
      "Savur",
      "Yeşilli"
    ]
  },
  {
    il: "Muğla",
    plaka: 48,
    ilceleri: [
      "Bodrum",
      "Dalaman",
      "Datça",
      "Fethiye",
      "Kavaklıdere",
      "Köyceğiz",
      "Marmaris",
      "Menteşe",
      "Milas",
      "Ortaca",
      "Seydikemer",
      "Ula",
      "Yatağan"
    ]
  },
  {
    il: "Muş",
    plaka: 49,
    ilceleri: [
      "Bulanık",
      "Hasköy",
      "Korkut",
      "Malazgirt",
      "Merkez",
      "Varto"
    ]
  },
  {
    il: "Nevşehir",
    plaka: 50,
    ilceleri: [
      "Acıgöl",
      "Avanos",
      "Derinkuyu",
      "Gülşehir",
      "Hacıbektaş",
      "Kozaklı",
      "Merkez",
      "Ürgüp"
    ]
  },
  {
    il: "Niğde",
    plaka: 51,
    ilceleri: [
      "Altunhisar",
      "Bor",
      "Çamardı",
      "Çiftlik",
      "Merkez",
      "Ulukışla"
    ]
  },
  {
    il: "Ordu",
    plaka: 52,
    ilceleri: [
      "Akkuş",
      "Altınordu",
      "Aybastı",
      "Çamaş",
      "Çatalpınar",
      "Çaybaşı",
      "Fatsa",
      "Gölköy",
      "Gülyalı",
      "Gürgentepe",
      "İkizce",
      "Kabadüz",
      "Kabataş",
      "Korgan",
      "Kumru",
      "Mesudiye",
      "Perşembe",
      "Ulubey",
      "Ünye"
    ]
  },
  {
    il: "Rize",
    plaka: 53,
    ilceleri: [
      "Ardeşen",
      "Çamlıhemşin",
      "Çayeli",
      "Derepazarı",
      "Fındıklı",
      "Güneysu",
      "Hemşin",
      "İkizdere",
      "İyidere",
      "Kalkandere",
      "Merkez",
      "Pazar"
    ]
  },
  {
    il: "Sakarya",
    plaka: 54,
    ilceleri: [
      "Adapazarı",
      "Akyazı",
      "Arifiye",
      "Erenler",
      "Ferizli",
      "Geyve",
      "Hendek",
      "Karapürçek",
      "Karasu",
      "Kaynarca",
      "Kocaali",
      "Pamukova",
      "Sapanca",
      "Serdivan",
      "Söğütlü",
      "Taraklı"
    ]
  },
  {
    il: "Samsun",
    plaka: 55,
    ilceleri: [
      "Alaçam",
      "Asarcık",
      "Atakum",
      "Ayvacık",
      "Bafra",
      "Canik",
      "Çarşamba",
      "Havza",
      "İlkadım",
      "Kavak",
      "Ladik",
      "Ondokuzmayıs",
      "Salıpazarı",
      "Tekkeköy",
      "Terme",
      "Vezirköprü",
      "Yakakent"
    ]
  },
  {
    il: "Siirt",
    plaka: 56,
    ilceleri: [
      "Baykan",
      "Eruh",
      "Kurtalan",
      "Merkez",
      "Pervari",
      "Şirvan",
      "Tillo"
    ]
  },
  {
    il: "Sinop",
    plaka: 57,
    ilceleri: [
      "Ayancık",
      "Boyabat",
      "Dikmen",
      "Durağan",
      "Erfelek",
      "Gerze",
      "Merkez",
      "Saraydüzü",
      "Türkeli"
    ]
  },
  {
    il: "Sivas",
    plaka: 58,
    ilceleri: [
      "Akıncılar",
      "Altınyayla",
      "Divriği",
      "Doğanşar",
      "Gemerek",
      "Gölova",
      "Gürün",
      "Hafik",
      "İmranlı",
      "Kangal",
      "Koyulhisar",
      "Merkez",
      "Suşehri",
      "Şarkışla",
      "Ulaş",
      "Yıldızeli",
      "Zara"
    ]
  },
  {
    il: "Tekirdağ",
    plaka: 59,
    ilceleri: [
      "Çerkezköy",
      "Çorlu",
      "Ergene",
      "Hayrabolu",
      "Kapaklı",
      "Malkara",
      "Marmaraereğlisi",
      "Muratlı",
      "Saray",
      "Süleymanpaşa",
      "Şarköy"
    ]
  },
  {
    il: "Tokat",
    plaka: 60,
    ilceleri: [
      "Almus",
      "Artova",
      "Başçiftlik",
      "Erbaa",
      "Merkez",
      "Niksar",
      "Pazar",
      "Reşadiye",
      "Sulusaray",
      "Turhal",
      "Yeşilyurt",
      "Zile"
    ]
  },
  {
    il: "Trabzon",
    plaka: 61,
    ilceleri: [
      "Akçaabat",
      "Araklı",
      "Arsin",
      "Beşikdüzü",
      "Çarşıbaşı",
      "Çaykara",
      "Dernekpazarı",
      "Düzköy",
      "Hayrat",
      "Köprübaşı",
      "Maçka",
      "Of",
      "Ortahisar",
      "Sürmene",
      "Şalpazarı",
      "Tonya",
      "Vakfıkebir",
      "Yomra"
    ]
  },
  {
    il: "Tunceli",
    plaka: 62,
    ilceleri: [
      "Çemişgezek",
      "Hozat",
      "Mazgirt",
      "Merkez",
      "Nazımiye",
      "Ovacık",
      "Pertek",
      "Pülümür"
    ]
  },
  {
    il: "Şanlıurfa",
    plaka: 63,
    ilceleri: [
      "Akçakale",
      "Birecik",
      "Bozova",
      "Ceylanpınar",
      "Eyyübiye",
      "Halfeti",
      "Haliliye",
      "Harran",
      "Hilvan",
      "Karaköprü",
      "Siverek",
      "Suruç",
      "Viranşehir"
    ]
  },
  {
    il: "Uşak",
    plaka: 64,
    ilceleri: [
      "Banaz",
      "Eşme",
      "Karahallı",
      "Merkez",
      "Sivaslı",
      "Ulubey"
    ]
  },
  {
    il: "Van",
    plaka: 65,
    ilceleri: [
      "Bahçesaray",
      "Başkale",
      "Çaldıran",
      "Çatak",
      "Edremit",
      "Erciş",
      "Gevaş",
      "Gürpınar",
      "İpekyolu",
      "Muradiye",
      "Özalp",
      "Saray",
      "Tuşba"
    ]
  },
  {
    il: "Yozgat",
    plaka: 66,
    ilceleri: [
      "Akdağmadeni",
      "Aydıncık",
      "Boğazlıyan",
      "Çandır",
      "Çayıralan",
      "Çekerek",
      "Kadışehri",
      "Merkez",
      "Saraykent",
      "Sarıkaya",
      "Sorgun",
      "Şefaatli",
      "Yenifakılı",
      "Yerköy"
    ]
  },
  {
    il: "Zonguldak",
    plaka: 67,
    ilceleri: [
      "Alaplı",
      "Çaycuma",
      "Devrek",
      "Ereğli",
      "Gökçebey",
      "Merkez"
    ]
  },
  {
    il: "Aksaray",
    plaka: 68,
    ilceleri: [
      "Ağaçören",
      "Eskil",
      "Gülağaç",
      "Güzelyurt",
      "Merkez",
      "Ortaköy",
      "Sarıyahşi"
    ]
  },
  {
    il: "Bayburt",
    plaka: 69,
    ilceleri: [
      "Aydıntepe",
      "Demirözü",
      "Merkez"
    ]
  },
  {
    il: "Karaman",
    plaka: 70,
    ilceleri: [
      "Ayrancı",
      "Başyayla",
      "Ermenek",
      "Kazımkarabekir",
      "Merkez",
      "Sarıveliler"
    ]
  },
  {
    il: "Kırıkkale",
    plaka: 71,
    ilceleri: [
      "Bahşili",
      "Balışeyh",
      "Çelebi",
      "Delice",
      "Karakeçili",
      "Keskin",
      "Merkez",
      "Sulakyurt",
      "Yahşihan"
    ]
  },
  {
    il: "Batman",
    plaka: 72,
    ilceleri: [
      "Beşiri",
      "Gercüş",
      "Hasankeyf",
      "Kozluk",
      "Merkez",
      "Sason"
    ]
  },
  {
    il: "Şırnak",
    plaka: 73,
    ilceleri: [
      "Beytüşşebap",
      "Cizre",
      "Güçlükonak",
      "İdil",
      "Merkez",
      "Silopi",
      "Uludere"
    ]
  },
  {
    il: "Bartın",
    plaka: 74,
    ilceleri: [
      "Amasra",
      "Kurucaşile",
      "Merkez",
      "Ulus"
    ]
  },
  {
    il: "Ardahan",
    plaka: 75,
    ilceleri: [
      "Çıldır",
      "Damal",
      "Göle",
      "Hanak",
      "Merkez",
      "Posof"
    ]
  },
  {
    il: "Iğdır",
    plaka: 76,
    ilceleri: [
      "Aralık",
      "Karakoyunlu",
      "Merkez",
      "Tuzluca"
    ]
  },
  {
    il: "Yalova",
    plaka: 77,
    ilceleri: [
      "Altınova",
      "Armutlu",
      "Çınarcık",
      "Çiftlikköy",
      "Merkez",
      "Termal"
    ]
  },
  {
    il: "Karabük",
    plaka: 78,
    ilceleri: [
      "Eflani",
      "Eskipazar",
      "Merkez",
      "Ovacık",
      "Safranbolu",
      "Yenice"
    ]
  },
  {
    il: "Kilis",
    plaka: 79,
    ilceleri: [
      "Elbeyli",
      "Merkez",
      "Musabeyli",
      "Polateli"
    ]
  },
  {
    il: "Osmaniye",
    plaka: 80,
    ilceleri: [
      "Bahçe",
      "Düziçi",
      "Hasanbeyli",
      "Kadirli",
      "Merkez",
      "Sumbas",
      "Toprakkale"
    ]
  },
  {
    il: "Düzce",
    plaka: 81,
    ilceleri: [
      "Akçakoca",
      "Cumayeri",
      "Çilimli",
      "Gölyaka",
      "Gümüşova",
      "Kaynaşlı",
      "Merkez",
      "Yığılca"
    ]
  }
];

export default ililce;



// WEBPACK FOOTER //
// ./src/helpers/ililce.js